<div id="wrapper">
    @if (organisationHeirarchy && !incorrectDetails) {
    <div class="main-div">
        <div class="header">
            <div class="icon">⇄</div>

            <div>
                <h2>Switching Account</h2>
                <p>We found the account and organisation you requested.</p>
            </div>
        </div>

        @if (currentUser.AdminSite) {
        <div class="details">
            <div class="detail-row">
                <span class="label">Account</span>
                <span class="value">{{accountGUID}}</span>
            </div>

            <div class="detail-row">
                <span class="label">Organisation</span>
                <span class="value">{{organisationUID}}</span>
            </div>
        </div>
        }

        @if (organisationHeirarchyFound) {
        <div class="status success">
            <span class="status-icon">✓</span>
            <span>Navigating to account dashboard...</span>
        </div>
        }
    </div>
    }
    @else if (incorrectDetails) {
    <div class="main-div error-container">
        <div class="icon error-icon">⇄</div>

        <h2>Unable to switch account</h2>

        <p>
            We were unable to locate the account details provided.
            Please return home and try again.
        </p>

        <button routerLink="/">Go Back Home</button>
    </div>
    }
    @else {
    <!-- <div class="main-div loading-container"> -->
    <app-loading-template DisplayText="Please wait while we load your account and organisation" />
    <!-- </div> -->
    }
</div>